import { color, MiscUtils } from '@my/util'
import { ActionButton, SimpleText, XStack, YStack, Image, ImageProps, Circle, useMedia } from '@my/ui'
import images from '../../assets/images'

interface ProfileHeaderProps {
  name: string
  image: any
}

// ProfileHeader Component to display basic profile information
export const ProfileComponent: React.FC<ProfileHeaderProps> = (props) => {
  const media = useMedia();
  const { name, image } = props
  return (
    <XStack alignItems="center" justifyContent="space-between" style={{width: '100%'}}>
      {/* Profile Image */}
      <Circle size="$6" backgroundColor="#C4C4C4" overflow="hidden">
        <Image
          src={image || images?.advisorDummy}
          style={{width: '100%', height: '100%'}}
          resizeMode="cover"
        />
      </Circle>

      {/* Profile Info */}
      <YStack flex={1} ml="$4">
        <XStack alignItems="center" justifyContent="space-between">
          <YStack flex={1} gap={5}>
            <SimpleText fontSize={17} color={color.grey} fontWeight={'700'}>
              {name}
            </SimpleText>
            <SimpleText lineHeight={16} fontSize={14} color={color.black} fontWeight={'400'}>
              (This is a fabricated advisor for demo purposes.)
            </SimpleText>
          </YStack>

          {/* Chat Button */}
          {media['max-sm'] ? null : <ActionButton
            circular
            height={38}
            width={38}
            bg="#fff"
            shadowColor="rgba(0, 0, 0, 0.1)"
            shadowOpacity={0.3}
            shadowRadius={5}
            shadowOffset={{ width: 0, height: 1 }}
            onPress={() => MiscUtils.dialog.alert("Coming Soon! Stay tuned.")}

          >
            <Image
              src={images.VideoCalling}
              style={{ height: 25, width: 25 }}
              tintColor={color.tzaGreen}
              resizeMode="contain"
            />
          </ActionButton>}
        </XStack>
      </YStack>
    </XStack>
  )
}
